import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BaseInquiryScrollSliderEnum } from '../../_enums/base-inquiry-scrolling-meta-data.enum';
import { BaseInquiryScrollService } from '../../_services/base-inquiry-scroll.service';

@Component({
  selector: 'base-inquiries-calendar-meta',
  templateUrl: 'base-inquiries-calendar-meta.component.html',
})
export class BaseInquiriesCalendarMetaComponent implements OnInit, OnDestroy {
  @Input() datesQty = 0;
  @Input() isCustomisedTooltip = false;

  isScrollStartPosition = true;
  baseInquiryScrollSliderEnum = BaseInquiryScrollSliderEnum;

  private destroy$ = new Subject<boolean>();

  constructor(private baseInquiryScrollService: BaseInquiryScrollService) {}

  ngOnInit() {
    this.baseInquiryScrollService.isScrollOnStart$.pipe(takeUntil(this.destroy$)).subscribe((isScrollStartPosition) => {
      this.isScrollStartPosition = isScrollStartPosition;
    });
  }

  ngOnDestroy() {
    this.baseInquiryScrollService.setSliderOffsetValue(0);
    this.destroy$.next(true);
  }

  navigateCalendar(value: BaseInquiryScrollSliderEnum): void {
    this.baseInquiryScrollService.setSliderOffsetValue(value, this.datesQty);
  }
}
